import { render } from "./DynamicContentForm.vue?vue&type=template&id=3e9e8d9f&scoped=true"
import script from "./DynamicContentForm.vue?vue&type=script&lang=js"
export * from "./DynamicContentForm.vue?vue&type=script&lang=js"

import "./DynamicContentForm.vue?vue&type=style&index=0&id=3e9e8d9f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e9e8d9f"]])

export default __exports__